import { z } from "zod";

const Id = z.string().min(1).max(64);

/** Material an Ideen und Projekten (UX-06). */
export const Material = z.object({
  id: Id,
  ideaId: Id.nullable(),
  projectId: Id.nullable(),
  kind: z.enum(["note", "link", "image", "file"]),
  title: z.string(),
  note: z.string(),
  url: z.string().nullable(),
  mime: z.string().nullable(),
  sizeBytes: z.number().int().nonnegative(),
  inRepo: z.boolean(),
  repoPath: z.string().nullable(),
  createdAt: z.string(),
});
export type Material = z.infer<typeof Material>;

const Title = z.string().trim().min(1, "Titel fehlt").max(200);
const Note = z.string().max(2000).default("");

/** Neues Material: Notiz, Link oder Datei (Base64, höchstens 10 MB; Bilder verkleinert das Studio vorher). */
export const AddMaterialInput = z.discriminatedUnion("kind", [
  z.strictObject({ kind: z.literal("note"), title: Title, text: z.string().trim().min(1).max(20000) }),
  z.strictObject({ kind: z.literal("link"), title: Title, url: z.url({ protocol: /^https?$/ }).max(2000), note: Note }),
  z.strictObject({
    kind: z.literal("file"),
    fileName: z.string().trim().min(1).max(200),
    contentBase64: z.string().min(1).max(14_000_000),
    note: Note,
  }),
]);
export type AddMaterialInput = z.infer<typeof AddMaterialInput>;

export const UpdateMaterialInput = z.strictObject({
  note: z.string().max(20000).optional(),
  inRepo: z.boolean().optional(),
});
export type UpdateMaterialInput = z.infer<typeof UpdateMaterialInput>;
